<template>
  <div
    class="ms-auto w-md-auto mt-2"
    v-if="ClamIdentifie !== 'igenyazonosito' && $store.state.page >= showFromPage"
  >
    <button @click="generateClaimIdentifier('igenyazonosito')" class="btn btn-red claim-identifier">
      Díjszámítási pdf létrehozása
    </button>
  </div>
  <div
    class="ms-auto w-md-auto mt-2"
    v-else-if="$store.state.igeny_azon_href && $store.state.page >= showFromPage"
  >
    <a :href="$store.state.igeny_azon_href" target="_blank" class="btn btn-red claim-identifier"
      >Díjszámítás letöltése pdf-ben</a
    >
  </div>
  <div
    class="ms-auto w-md-auto mt-2"
    v-else-if="$store.state.page >= showFromPage && !$store.state.igeny_azon_href"
  >
    <button class="btn btn-red claim-identifier">
      Kérem várjon
    </button>
  </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  props: ['showFromPage'],
  methods: {
    ...mapActions(['verifyPage']),
    async generateClaimIdentifier(code) {
      this.$store.commit('setClaimIdentifier', code);
      await this.verifyPage(7);
      this.$store.commit('setNavigationBackButton', true);
    },
  },
  computed: {
    ClamIdentifie() {
      return this.$store.state.code;
    },
  },
};
</script>
